// App.jsx - CORRECTED VERSION
import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Provider, useSelector, useDispatch } from "react-redux";
import { store } from "./redux/store";
import { AdminLogin } from "./components/admin/AdminLogin";
import { restoreSession } from "./redux/slice";
import UserManagementCreate from "./components/admin/UserManagementCreate";
import DashboardDetails from "./components/DashboardDetails";
import SubscriptionPage from "./components/admin/SubscriptionPage";
import AdminProfile from "./components/admin/AdminProfile";

function AppContent() {
  const dispatch = useDispatch();
  const { isAuthenticated, sessionChecked, loading, error, user, token } =
    useSelector((state) => state.auth);

  // Log state changes for debugging
  useEffect(() => {
    console.log("App State:", {
      isAuthenticated,
      sessionChecked,
      loading,
      error,
      user,
      token,
    });
  }, [isAuthenticated, sessionChecked, loading, error, user, token]);

  // Restore session on app load
  useEffect(() => {
    dispatch(restoreSession());
  }, [dispatch]);

  // Loading spinner while checking session
  if (!sessionChecked) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Checking authentication...</p>
        </div>
      </div>
    );
  }

  return (
    <Router>
      <Routes>
        {/* Public Route */}
        <Route
          path="/login"
          element={
            !isAuthenticated ? (
              <AdminLogin />
            ) : (
              <Navigate to="/admin/dashboard" replace />
            )
          }
        />

        {/* Protected Routes (accessible only when authenticated) */}
        <Route
          path="/admin/user-management/create/:tab?"
          element={
            isAuthenticated ? (
              <UserManagementCreate />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/admin/user-management/edit/:id/:tab?"
          element={
            isAuthenticated ? (
              <UserManagementCreate />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />

        <Route
           path="/admin/plan/:profileId"
          element={
            isAuthenticated ? (
              <SubscriptionPage />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        
        <Route
           path="/admin/profile"
          element={
            isAuthenticated ? (
              <AdminProfile />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />

        
        <Route
          path="/admin/*"
          element={
            isAuthenticated ? (
              <DashboardDetails />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />

        {/* Default redirect */}
        <Route
          path="/"
          element={
            <Navigate
              to={isAuthenticated ? "/admin/dashboard" : "/login"}
              replace
            />
          }
        />



        {/* Catch-all route */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default function App() {
  return (
    <Provider store={store}>
      <AppContent />
    </Provider>
  );
}